import type { FaireProductEntity } from "../../entity_types/product";

export const p_gycxdwg4hq: FaireProductEntity = {
  token: "p_gycxdwg4hq",
  type: "product",
  name: "CWDHL0939_NEW SUMMER FRENCH FLORAL SLIM SUSPENDER DRESS",
  brandToken: "b_gd86yguu29",
  brandName: "NINEXIS",
  imageUrl:
    "https://cdn.faire.com/fastly/a78ddf1470fd606df2cdecad9dc5328f61720feb4f09a55118cd216231081dbf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/36168650be8b1f25efa8ea73e629627a7ece0ac678577872330b241daaf48e57.jpeg",
    "https://cdn.faire.com/fastly/4b4e64ef3a97cc1650c2df4d2163dc110090c48ec0522d58dba7af4241b16480.jpeg",
    "https://cdn.faire.com/fastly/a5e4120f56c1d28dee478c818f663056f43e742e3d19af530dd71316f7602d6e.jpeg",
    "https://cdn.faire.com/fastly/8dd76c0d52b3508512eb06a1d01a7865ff0676de6b3640f808715a4f97ca9b84.jpeg",
    "https://cdn.faire.com/fastly/b613636a4b4887fa8e1d9249a56304f005d471aab071bf546275e166d1aba839.jpeg",
    "https://cdn.faire.com/fastly/779b20f17e4e290449f03b880763b56ad28cf4c573faf1ecb2218fe104f26c4e.jpeg",
    "https://cdn.faire.com/fastly/40a1bbb9dccce506be7885ef7845544ea371f6d7a783414200c239a4bc1b2cee.jpeg",
    "https://cdn.faire.com/fastly/d8ae7ba4cf9bb56abe29193de242a893866682eb0f2882aaa18f15670ebca833.jpeg",
  ],
  priceDollars: 18.9,
  description:
    "NEW SUMMER FRENCH FLORAL SLIM SUSPENDER DRESS\n100%POLYESTER\nSIZE  S / M / L / XL\nMADE IN CHINA\n\nDRESSES FOR WOMEN, DRESS, DRESSES FOR WOMEN SPRING, DRESS FORUM, DRESSER, DRESS PANTS, DRESSY TOPS, DRESS WITH POCKETS, DRESSED IN LALA, DRESSES SPRING, DRESSES FOR WOMEN SUMMER, DRESSES FOR WOMEN FORMAL,MIDI DRESS, FLORAL DRESS, PLUS SIZE DRESS, SLIT DRESS, MAXI DRESS, DRESSES FOR WOMEN WINTER, DRESSES FOR WOMEN MODEST, OVERSIZED DRESS, WOMEN DRESS, LOOSE FIT DRESS, BOHEMIAN DRESS, COLOR BLOCK DRESS, KNIT DRESS, WESTERN DRESS, SPRING APPAREL, SUMMER APPAREL, LONG SLEEVE DRESS, SHOT SLEEVE DRESS, PATCHWORK DRESS, FALL DRESS，SUMMER,SPRING.SUMMER EPIDEMIC,SPRING FASHION",
  tags: [],
  msrpDollars: 37.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:51.699Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
